import script from "./OnboardingAiBookDemoStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiBookDemoStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiBookDemoStep.vue?vue&type=style&index=0&id=67932190&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67932190"]])

export default __exports__